"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_OPTIONS = void 0;
/* eslint-disable import/prefer-default-export */
const visa_master_png_1 = __importDefault(require("../../../../static/payments/visa_master.png"));
const googlepay_svg_1 = __importDefault(require("../../../../static/payments/googlepay.svg"));
const ideal_svg_1 = __importDefault(require("../../../../static/payments/ideal.svg"));
const turkishbank_png_1 = __importDefault(require("../../../../static/payments/turkishbank.png"));
const poli_png_1 = __importDefault(require("../../../../static/payments/poli.png"));
const sepa_svg_1 = __importDefault(require("../../../../static/payments/sepa.svg"));
const applepay_svg_1 = __importDefault(require("../../../../static/payments/applepay.svg"));
const interac_png_1 = __importDefault(require("../../../../static/payments/interac.png"));
const fasterpayments_svg_1 = __importDefault(require("../../../../static/payments/fasterpayments.svg"));
const pix_png_1 = __importDefault(require("../../../../static/payments/pix.png"));
const payid_png_1 = __importDefault(require("../../../../static/payments/payid.png"));
const instantbanktransfer_png_1 = __importDefault(require("../../../../static/payments/instantbanktransfer.png"));
const pse_svg_1 = __importDefault(require("../../../../static/payments/pse.svg"));
const thaiqr_png_1 = __importDefault(require("../../../../static/payments/thaiqr.png"));
const khipu_png_1 = __importDefault(require("../../../../static/payments/khipu.png"));
const spei_svg_1 = __importDefault(require("../../../../static/payments/spei.svg"));
exports.PAYMENT_OPTIONS = [
    { id: "WORLDPAYCREDIT", icon: visa_master_png_1.default },
    { id: "CHECKOUTCREDIT", icon: visa_master_png_1.default },
    { id: "WORLDPAYGOOGLE", icon: googlepay_svg_1.default },
    { id: "IDEAL", icon: ideal_svg_1.default },
    { id: "MANUALPAYMENT", icon: turkishbank_png_1.default },
    { id: "POLI", icon: poli_png_1.default },
    { id: "CLEARJUNCTION", icon: sepa_svg_1.default },
    { id: "apple_pay", icon: applepay_svg_1.default },
    { id: "DCINTERAC", icon: interac_png_1.default },
    { id: "CLEARJUNCTIONFP", icon: fasterpayments_svg_1.default },
    { id: "DLOCALPIX", icon: pix_png_1.default },
    { id: "MONOOVAPAYID", icon: payid_png_1.default },
    { id: "DLOCALZAIO", icon: instantbanktransfer_png_1.default },
    { id: "DLOCALZAIO", icon: instantbanktransfer_png_1.default },
    { id: "DLOCALCOPSE", icon: pse_svg_1.default },
    { id: "DLOCALSPEI", icon: spei_svg_1.default },
    { id: "DLOCALCLKH", icon: khipu_png_1.default },
    { id: "DLOCALTHQR", icon: thaiqr_png_1.default },
];
//# sourceMappingURL=constants.js.map